export default "__VITE_ASSET__CJt1N3xk__"